/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// utils
import FileUtils from "utils/file-utils/FileUtils.js";

const FileInput = (props) => {
  const { className, style } = props;
  return (
    <input
      className={className || ""}
      id={FileUtils.getUploadElementId()}
      style={{ display: "none", ...style }}
      type={"file"}
    />
  );
};
export default FileInput;
